import { useEffect, useState } from 'react';
import { authAPI, myVehiclesAPI } from './api';

const EVENT = 'garage-changed';
let cache = null;
let pending = null;

// Vehicles saved in the customer's account (Mon compte › Garage), cached in memory
export const garageStore = {
  list: () => cache || [],
  load: async (force = false) => {
    if (!authAPI.isAuthenticated()) { cache = []; return cache; }
    if (cache && !force) return cache;
    if (!pending) {
      pending = myVehiclesAPI.list().then(v => { cache = v; window.dispatchEvent(new Event(EVENT)); return v; }).catch(() => cache || []).finally(() => { pending = null; });
    }
    return pending;
  },
  invalidate: () => { cache = null; garageStore.load(true); },
  reset: () => { cache = []; window.dispatchEvent(new Event(EVENT)); },
};

export const useGarage = () => {
  const [vehicles, setVehicles] = useState(garageStore.list);
  useEffect(() => {
    const h = () => setVehicles(garageStore.list());
    window.addEventListener(EVENT, h);
    garageStore.load();
    return () => window.removeEventListener(EVENT, h);
  }, []);
  return vehicles;
};
